import { isValidPhoneNumber } from "react-phone-number-input";
import * as yup from "yup";

export const updateProfileSchema = yup.object().shape({
  lastName: yup.string().required("Last name is required"),
  firstName: yup.string().required("First name is required"),

  // bvn: yup
  //   .string()
  //   .matches(/^[0-9]+$/, "Must be only digits")
  //   .min(11, "Must be exactly 11 digits")
  //   .max(11, "Must be exactly 11 digits")
  //   .nullable()
  //   .typeError("BVN is required"),
  phone: yup
    .string()
    .required("Phone Number is required")
    .test({
      name: "valid",
      message: "Phone number must be valid",
      test: function (value) {
        return value?.length == 14 && isValidPhoneNumber(value);
      },
    }),

  // nin: yup
  //   .string()
  //   .matches(/^[0-9]+$/, "Must be only digits")
  //   .min(11, "Must be exactly 11 digits")
  //   .max(11, "Must be exactly 11 digits")
  //   .required("NIN is required")
  //   .nullable()
  //   .typeError("NIN is required"),
});
